import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  DeleteTrashBinAggregateBusinessRequest,
  DeleteTrashBinBusinessSuccessResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/trashBinManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';

/**
 * DeleteTrashAggregateBinBusinessUseCase
 */
export class DeleteTrashBinAggregateBusinessUseCase {
  /**
   * ゴミ箱内の集計情報を削除するUseCase
   * @param repository - ゴミ箱のリポジトリ
   * @param trashBinAggregateBusinessIdArray - 削除する集計情報のID一覧
   */
  static async Execute(
    repository: ITrashBinRepository,
    trashBinAggregateBusinessIdArray: Array<string>
  ): Promise<INetworkResult<DeleteTrashBinBusinessSuccessResponseInfo, IError>> {
    const request: DeleteTrashBinAggregateBusinessRequest = {
      deleteTrashBinAggregateBusinessIdArray: trashBinAggregateBusinessIdArray,
    };
    const networkResult = await repository.deleteTrashBinAggregateBusiness(request);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
